<template>
  <div class="container-fluid">
    <div class="integration-header">
      <div class="integration-header--title d-flex">
        <img
          class="Thumb Thumb--48"
          :src="integrationIcon"
          :alt="integrationName"
        />
        <h1 class="ml-2">{{integrationName}}</h1>
      </div>
      <div class="col-md-2 col-sm-12">
        <button
          class="Fuell-Button block blue"
          :disabled="!isDirty || isLoading"
          @click="saveChanges"
        >{{$t('ACTION_SAVE')}}</button>

      </div>
    </div>
    <div class="integration-settings-box">
      <div class="row w-100">
        <div class="col- col-md-4 mt-3">
          <div class="input--block">
            <label
              for=""
              class="form--label"
            >{{$t('company_integrations_settings_holded_payment_account_number').toUpperCase()}}</label>
            <div class="Form-field">
              <input
                class="Input-text"
                :placeholder="$t('company_integrations_settings_holded_payment_account_number')"
                type="text"
                v-model.trim="holdedConfig.config.paymentAccountNumber"
                id=""
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-center"
        v-if="isLoading"
      >
        <spinner />

      </div>
    </div>
  </div>
</template>

<script>

import { erpOfficeConfigurationData } from '../../_utils/IntegrationsConfigData'
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'IntegrationDetailIndex',
  components: { Spinner },
  data () {
    return {
      holdedConfig: {
        code: 'HOLDED_ERP',
        config: { paymentAccountNumber: null }
      },
      isLoading: false
    }
  },
  computed: {
    integrationName () {
      return this.$route.params.erp
    },
    erpOfficeConfigurationData () {
      return erpOfficeConfigurationData
    },
    integrationConfiguration () {
      return this.erpOfficeConfigurationData.find(el => el.integrationName === this.integrationName) || false
    },
    integrationIcon () {
      return this.integrationConfiguration ? this.integrationConfiguration.integrationIcon : null
    },
    currentCompany () {
      return this.$store.getters['CompanyStore/currentCompany']
    },
    currentCompanyConfigs () {
      return this.$store.getters['CompanyStore/currentCompanyConfigs']
    },
    currentCompanyIntegrationConfigurationData () {
      return this.currentCompanyConfigs.find(el => el.code === this.integrationConfiguration.officeConfigKey) || false
    },
    isDirty () {
      return this.holdedConfig.config.paymentAccountNumber !== this.currentCompanyIntegrationConfigurationData.config.paymentAccountNumber
    }

  },
  methods: {
    async saveChanges () {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const config = {
          configs: [
            { ...this.holdedConfig }
          ]
        }
        await this.$store.dispatch('CompanyStore/updateCompany', { officeId: this.currentCompany.id, updateInformation: { ...config } })
        this.$store.dispatch('SnackBars/addSuccess', this.$t('company_intragrations_settings_config_updated_success'), { root: true })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'company_integrations_settings_config_updated_error' }, { root: true })
      } finally {
        this.isLoading = false
      }
    }
  },
  created () {
    this.holdedConfig.config.paymentAccountNumber = this.currentCompanyIntegrationConfigurationData.config.paymentAccountNumber
  },

  beforeRouteEnter (to, from, next) {
    if (to.params.erp !== 'holded') {
      next({ name: 'integrations' })
    } else {
      next()
    }
  }
}
</script>

<style scoped>
.integration-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.integration-header--title > h1 {
  margin: 0px;
  text-transform: capitalize;
}
.integration-settings-box {
  margin-top: 20px;
}
.Thumb--48 {
  flex: 0 0 48px;
  max-width: 48px;
  max-height: 48px;
  width: 100%;
  height: 100%;
}
@media screen and (max-width:576px) {
  .integration-header {
    flex-direction: column;

  }
  .Fuell-Button {
    margin-top:20px;
  }

}
</style>
